import { Pipe, PipeTransform } from '@angular/core';

const APP_TIME_ZONE = 'America/Sao_Paulo';

export function dataLocalParaInput(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(date);

  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values['year']}-${values['month']}-${values['day']}`;
}

export function formatarDataLocal(value: unknown, formato: 'default' | 'short' = 'default') {
  if (!value) return '';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return String(value);

  const ano = formato === 'short' ? match[1].slice(2) : match[1];
  return `${match[3]}/${match[2]}/${ano}`;
}

export function formatarDataHoraLocal(value: unknown) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(String(value));
  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: APP_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date).replace(',', '');
}

@Pipe({ name: 'localDate', standalone: true })
export class LocalDatePipe implements PipeTransform {
  transform(value: unknown, formato: 'default' | 'short' = 'default') {
    return formatarDataLocal(value, formato);
  }
}

@Pipe({ name: 'localDateTime', standalone: true })
export class LocalDateTimePipe implements PipeTransform {
  transform(value: unknown) {
    return formatarDataHoraLocal(value);
  }
}
